<template>
    <div>
        <div class="node-title">{{$t('approvalFlowConfigManagement.Node.title')}}</div>
        <div class="node-top">
            <node-search></node-search>
        </div>
        <table-node></table-node>
    </div>
</template>

<script>
    import NodeSearch from '../node/NodeSearch'
    import TableNode from '../node/TableNode'

    export default {
        name: 'Node',
        components: {
            NodeSearch,
            TableNode
        }
    }
</script>

<style scoped>
    .node-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 8px 4px;
        font-weight: 600;
    }
    .node-top
    {
        width: 100%;
        height: 53px;
    }
</style>



// WEBPACK FOOTER //
// src/components/configuration/approval_flow_configuration/node/Node.vue